export default __webpack_public_path__ + "static/media/txt3_pc@2x.c88384f2.png";